import { render, staticRenderFns } from "./CreditsHistorySkeleton.vue?vue&type=template&id=3afc70fc&scoped=true&"
import script from "./CreditsHistorySkeleton.vue?vue&type=script&lang=ts&"
export * from "./CreditsHistorySkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc70fc",
  null
  
)

export default component.exports